window.angular
    .module('hippo', ['hippoComponents', 'hippo-consts', 'ngCookies', 'uuid'])
    .controller(
        'faqController',
        function (
            $scope,
            $window,
            $timeout,
            HIPPO_CONSTS,
            featureToggle,
            optionsService,
            userDataService,
            licenseService,
            $http
        ) {
            'ngInject';

            const { $, _ } = window;
            const isXfinityFlow = featureToggle.isXfinityFlow();

            $scope.HippoConsts = HIPPO_CONSTS;
            $scope.loaded = true;
            $scope.activePage = 0;
            $scope.showingState = null;
            $scope.licenses = _.sortBy(HIPPO_CONSTS.LICENSE_DETAILS, (license) => license.NAME);
            $scope.isOutsideLeadFlow = true;
            $scope.data = _.mapKeys(userDataService.getFlags(), (value, key) => _.camelCase(key)); // enable passing parameters on URL. used for example in 'discount-success.pug'
            $scope.isNewDesign = featureToggle.showNewDesign();

            if (isXfinityFlow) {
                $('body').addClass('xfinity');
            }

            const dp3States = licenseService.getUppercaseDp3States();
            $scope.dp3StatesString = licenseService.convertArrayToSentenceList(dp3States);

            // Careers
            const $greenhouseJobsElement = $('#hippo-careers');

            if ($greenhouseJobsElement.length) {
                $scope.departments = {};
                $http({
                    method: 'GET',
                    url: 'https://boards-api.greenhouse.io/v1/boards/hippo70/jobs?content=true'
                }).then((result) => {
                    result.data.jobs.forEach((job) => {
                        const department = job.departments[0].name;

                        if (!$scope.departments[department]) {
                            $scope.departments[department] = [];
                        }

                        $scope.departments[department].push({
                            location: job.offices[0].location,
                            title: job.title,
                            url: job.absolute_url + '&gh_src=7d5bf7a22'
                        });
                    });
                });
            }

            $timeout(() => {
                $('.static-page').css('display', 'block');

                // TODO: i think this is the previous accordion. doesn't work on prod
                $('.section-trigger').on('click', (event) => {
                    $(event.target).parents('.info-section').toggleClass('collapsed');
                    return false;
                });

                // mobile cta
                $('.sticky-get-instant-quote-button').on('click', (event) => {
                    $('.cta').addClass('active').find('.inputbox');
                    $('.inputbox').on('focus', (event) => {
                        $('.hippo, .mobile-address-input-title').hide();
                        document.body.scrollTop = 0;
                    });
                    $('body').addClass('landing-mobile-cta-clicked').removeClass('landing-desktop-cta-clicked');
                    if (!$scope.isNewDesign) {
                        $('.burger-container.burger-back-btn').hide();
                        $('.burger-container.burger').show();
                    }
                    $('.aux-page-content').hide();
                });

                // mobile nav
                $('.burger-container.burger-back-btn').on('click', (event) => {
                    $('.cta').removeClass('active');
                    $('body').removeClass('landing-mobile-cta-clicked').addClass('landing-desktop-cta-clicked');
                    $('.burger-container.burger-back-btn').hide();
                    $('.burger-container.burger, .aux-page-content').show();
                });

                const supportedStates = featureToggle.getSupportedStates();
                const supportedStatesMapName = supportedStates.join('-');

                _.each(supportedStates, (state) => {
                    $(`.${state}`).removeClass('hidden');
                    $(`.hippo-pin-${state.toLowerCase()}`).removeClass('hidden');
                });

                // NOTE: Need to update this to avoid failing the 'test-unused-images' task
                // These are the currently supported maps:
                // map-az-ca-tx.svg
                // map-az-ca-pa-tx.svg
                // map-az-ca-il-pa-tx.svg
                // map-az-ca-il-oh-pa-tx.svg
                // map-az-ca-oh-pa-tx.svg
                // map-az-ca-il-oh-pa-tn-tx.svg
                // map-az-ca-il-ms-oh-pa-tn-tx.svg
                // map-al-az-ca-il-oh-pa-tn-tx.svg
                // map-al-az-ca-il-ms-oh-pa-tn-tx.svg
                // map-al-az-ca-il-md-ms-oh-pa-tn-tx.svg
                // map-al-az-ca-il-md-ms-oh-pa-tn-tx-wi.svg
                // map-al-az-ca-il-md-ms-nv-oh-pa-tn-tx-wi.svg
                // map-al-az-ca-il-in-md-ms-nv-oh-pa-tn-tx-wi.svg
                // map-al-az-ca-il-in-md-mo-ms-nv-oh-pa-tn-tx-wi.svg
                // map-al-az-ca-il-in-md-mn-mo-ms-nv-oh-pa-tn-tx-wi.svg
                // map-al-az-ca-il-in-md-mn-mo-ms-nm-nv-oh-pa-tn-tx-wi.svg
                // map-al-az-ca-co-il-in-md-mn-mo-ms-nm-nv-oh-pa-tn-tx-wi.svg
                $('.map').attr('src', `/img/about/map-${supportedStatesMapName}.svg`);

                // new design accordion section
                $('.new-design .accordion-question').on('click', (event) => {
                    if ($(event.target).next('.open').length === 0) {
                        const $activeQuestion = $(event.target)
                            .parents('.accordion-section')
                            .find('.accordion-question.active');
                        const $openAnswer = $(event.target)
                            .parents('.accordion-section')
                            .find('.accordion-answer.open');
                        const $item = $(event.target).parent('.accordion-item');
                        const $content = $item.find('.accordion-answer');
                        $(event.target).addClass('active');
                        $activeQuestion.removeClass('active');
                        $content.addClass('open').slideToggle(100);
                        $openAnswer.removeClass('open').slideToggle(100);
                    }
                });
            }, 500);

            // For get a quote button on aux pages
            $scope.handleDeepEvent = function ($event) {
                const currParam = document.location.search;
                const address = $event.parameters.value;
                window.location.href = `/product-select${
                    currParam ? currParam + '&' : '?'
                }prefilledAddress=${JSON.stringify(address)}${isXfinityFlow ? '&partner=xfinity' : ''}`;
            };

            $scope.showState = function ($event) {
                const state = $event.currentTarget.classList[1].substr(10);
                const stateDetails = HIPPO_CONSTS.LICENSE_DETAILS[state.toUpperCase()];
                $scope.showingState = {
                    name: stateDetails.NAME,
                    license: stateDetails.LICENSE,
                    code: state
                };
            };

            $scope.hideState = function (state) {
                $scope.showingState = null;
            };

            // Anchor link scrolling
            $scope.scrollTo = function ($event) {
                const link = $($event.target);
                const active = link.parents('.category-filters-section').find('a.active');
                active.removeClass('active');
                link.addClass('active');
                const destination = $(link).attr('data-section');
                const sectionOffset = $(`#${destination}`).offset().top;
                $('html, body').animate({ scrollTop: sectionOffset - 80 }, 'slow');
            };

            setTimeout(() => {
                $('.cta').on('click', () => {
                    $('.cta').addClass('active');
                });
            }, 1000);

            const inViewport = function (elem, cb) {
                return elem.each(function (i, el) {
                    function visPx() {
                        const H = window.$(window).height();
                        const r = el.getBoundingClientRect();
                        const t = r.top;
                        const b = r.bottom;
                        return cb.call(el, Math.max(0, t > 0 ? H - t : b < H ? b : H));
                    }
                    visPx();
                    window.$(window).on('resize scroll', visPx);
                });
            };

            inViewport(window.$('.country-map'), function (px) {
                if (px) window.$(this).addClass('triggeredCSS3');
            });
        }
    );
